import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { metaOverrideSet } from './metaOverrideSet';
import { PM2JourneyRoadmapAdjustmentDiffLayout } from './layout';

export const PM2JourneyRoadmapAdjustmentDiffTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();

  return (
    <MetaResourceRenderer
      resource={resource}
      layout={withGuidedHouseholdReviewLayout(PM2JourneyRoadmapAdjustmentDiffLayout, {
        customButtons: true,
        hideSave: true,
        hideTitle: true,
        fullHeight: true,
      })}
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
    />
  );
};

PM2JourneyRoadmapAdjustmentDiffTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
